import React, { useEffect, useState } from 'react';
import SelectField from '../../../../../Components/Form/components/SelectField';
import FormControl from '../../../../../Components/Form/FormControl';
import WorkplaceOrWorkplaceMemberSelect from '../../../../Base/Components/WorkplaceOrWorkplaceMemberSelect/WorkplaceOrWorkplaceMemberSelect';
import { useEffectAsync } from '../../../../../helpers';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import {
	useSimpleWorkplaceMemberQuery,
	useWorkplaceHealthPlansQuery,
} from '../../../../../graphql/graphql';
import { useAppContext } from '../../../../../Services/AppContext';
import Loading from '../../../../../Components/Loading';
import useWorkplaceRole from '../../../../Workplace/Hooks/useWorkplaceRole';
import { HealthPlanCode } from '../../../../../Enums/HealthPlanCode.enum';
import useScope from '../../../../Scope/Hooks/useScope';

interface Props {
	formMethods: any;
	setHasHealthPlans?: (hasHealthPlans: boolean) => void;
}

const PatientRegistrationHealthPlanSelect: React.FC<Props> = ({
	formMethods,
	setHasHealthPlans,
}) => {
	const { workplaceId, userData } = useAppContext();
	const { data, isLoading } = useWorkplaceHealthPlansQuery();
	const { isKDARWorkplace } = useScope();
	const workplaceMember = useSimpleWorkplaceMemberQuery({
		userId: userData.id,
		workplaceId: workplaceId,
	});
	const [healthPlanCodeOptions, setHealthPlanCodeOptions] = useState<
		SelectValue[]
	>([]);
	const healthPlans = data?.workplaceHealthPlans;
	const healthPlanCodeValue = formMethods.watch('healthPlanCode')?.value;

	const { isDoctor } = useWorkplaceRole({
		userId: userData.id,
		workplaceId: workplaceId,
	});

	useEffectAsync(async () => {
		if (healthPlans?.data) {
			if (healthPlans?.data?.length > 0) {
				setHasHealthPlans?.(true);
			}
			const options: SelectValue[] = [
				{
					label: 'base.withoutHealthPlan',
					value: 'withoutPlan',
				},
			];
			healthPlans.data.map(({ name, code }: any) => {
				options.push({
					label: name,
					value: code,
				});
			});
			setHealthPlanCodeOptions(options);
		}
	}, [healthPlans]);

	useEffectAsync(async () => {
		if (workplaceMember && isDoctor) {
			formMethods.setValue('healthPlanWorkplaceMember', {
				label: workplaceMember?.data?.workplaceMember?.user?.profile?.fullName,
				value: workplaceMember?.data?.workplaceMember?.id,
			});
		}
	}, [workplaceMember]);

	useEffect(() => {
		if (isKDARWorkplace) {
			formMethods.setValue(
				'healthPlanCode',
				healthPlanCodeOptions.find(item => item.value === HealthPlanCode.KDAR),
			);
		}
	}, [healthPlanCodeOptions]);

	if (isLoading) {
		return <Loading />;
	}

	return healthPlans?.data && healthPlans?.data?.length > 0 ? (
		<>
			<SelectField
				name='healthPlanCode'
				label={
					isKDARWorkplace
						? 'base.registerPatientTo'
						: 'base.registerPatientToHealthPlan'
				}
				options={healthPlanCodeOptions}
				className={'mb-3'}
				isRequired
			/>
			{healthPlanCodeValue &&
				healthPlanCodeValue !== 'withoutPlan' &&
				healthPlanCodeValue !== HealthPlanCode.KDAR && (
					<FormControl
						name='healthPlanWorkplaceMember'
						label='component.patientManualRegistrationComponent.doctorForHealthPlan'
						isRequired>
						<WorkplaceOrWorkplaceMemberSelect
							filter={{
								workplaceId: workplaceId,
								searchWorkplaceMembersOnly: true,
							}}
							includeNurses={false}
						/>
					</FormControl>
				)}
		</>
	) : (
		<></>
	);
};

export default PatientRegistrationHealthPlanSelect;
